import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";

export default function PricingPage() {
  const [pricing, setPricing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    fetchPricing();
  }, []);

  async function fetchPricing() {
    setLoading(true);
    const { data, error } = await supabase
      .from("pricing")
      .select("id, month, type, price_per_day")
      .order("month", { ascending: true });

    if (error) {
      alert("Error fetching pricing: " + error.message);
    } else {
      setPricing(data || []);
    }
    setLoading(false);
  }

  async function savePrice(id) {
    const newPrice = editData[id];
    if (!newPrice) return;

    const { error } = await supabase
      .from("pricing")
      .update({ price_per_day: newPrice })
      .eq("id", id);

    if (error) {
      alert("Error updating price: " + error.message);
    } else {
      fetchPricing();
      alert("Price updated!");
    }
  }

  if (loading) return <div style={{ padding: 20 }}>Loading...</div>;

  return (
    <div style={{ padding: 20 }}>
      <h1>Pricing Management</h1>
      <table border="1" cellPadding="10">
        <thead>
          <tr>
            <th>Month</th>
            <th>Type</th>
            <th>Price per day (€)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {pricing.map((row) => (
            <tr key={row.id}>
              <td>{row.month}</td>
              <td>{row.type}</td>
              <td>
                <input
                  type="number"
                  defaultValue={row.price_per_day}
                  onChange={(e) =>
                    setEditData({ ...editData, [row.id]: e.target.value })
                  }
                />
              </td>
              <td>
                <button onClick={() => savePrice(row.id)}>Save</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
